import React, { useEffect, useRef, useState } from 'react'

import '../../message/Message.css'
import Iframe from '../../iframe/iframe'
import {
  checkShowLogo,
  defineMessageBorder,
  defineMessageMargin,
  messageContainerSize,
} from './config'
import { Typing } from '../../message/Typing/Typing'
import MessageBody from '../../message/MessageBody'
import CenteredLoader from '../../view/CenteredLoader'
import { isElementTop } from '../../../actions/static'
import { usePrevious } from '../../../hooks/usePrevious'
import classes from './styles.module.scss'

const MessageContainer = props => {
  const {
    postMessage,
    showTyping,
    textDisabled,
    messages,
    parentURL,
    device,
    settings,
    connected,
    isFullScreenWidget,
    openShare,
    isMobile,
    getMoreChatHistory,
    firstUnreadMessageId
  } = props

  const [showIframe, setShowIframe] = useState(false)
  const [iframeSrc, setIframeSrc] = useState('')
  const [changeScrollBehavior, setChangeScrollBehavior] = useState(false) // eslint-disable-line

  const [scrollPosition, setScrollPosition] = useState(null)
  const [scrollBehavior, setScrollBehavior] = useState('smooth')

  const scrollContainer = useRef(null)
  const messagesEnd = useRef(null)
  const firstUnreadMessageRef = useRef(null)
  const prevLastUserMessage = usePrevious(messages[messages.length - 1])

  const showLoader = !connected && !showTyping && messages.length <= 0
  const containerSize = messageContainerSize(
    device,
    textDisabled,
    isFullScreenWidget,
    scrollBehavior,
  )

  useEffect(() => {
    scrollToBottom()
  }, [showTyping, isFullScreenWidget])

  useEffect(() => {
    setTimeout(() => {
      if (firstUnreadMessageRef.current) {
        firstUnreadMessageRef.current.scrollIntoView({ behavior: 'smooth' })
      }
    }, 200)
    setTimeout(() => {
      setChangeScrollBehavior(true)
    }, 1000)
  }, [])

  useEffect(() => {
    if (
      prevLastUserMessage === 0 ||
      JSON.stringify(messages[messages.length - 1]) !==
        JSON.stringify(prevLastUserMessage)
    ) {
      scrollToBottom()
    } else {
      scrollContainer.current.scrollTop =
        scrollContainer.current.scrollHeight - scrollPosition
    }
  }, [messages.length])

  const onScroll = ({ target }) => {
    if (isElementTop(target)) {
      setScrollBehavior('auto')
      setScrollPosition(scrollContainer.current.scrollHeight)
      getMoreChatHistory()
    }
  }

  const openIframe = url => {
    setShowIframe(true)
    setIframeSrc(url)
  }

  const closeIframe = () => {
    setShowIframe(false)
  }

  const scrollToBottom = () => {
    if (messagesEnd.current) {
      messagesEnd.current.scrollIntoView()
    }
    setScrollBehavior('smooth')
  }

  return (
    <div
      ref={scrollContainer}
      className={classes.msgWrapContainer}
      onScroll={onScroll}
      style={containerSize}>
      {showLoader ? (
        <CenteredLoader
          position={'relative'}
          color={settings.color}
          size={40}
        />
      ) : (
        messages
          .slice()
          .map((message, index) => (
            <MessageBody
              key={index}
              device={device}
              message={message}
              parentURL={parentURL}
              settings={settings}
              isMobile={isMobile}
              openShare={openShare}
              openIframe={openIframe}
              firstUnreadMessageId={firstUnreadMessageId}
              isFullScreenWidget={isFullScreenWidget}
              showReply={index + 1 === messages.length}
              showLogo={checkShowLogo(messages, index)}
              messageBorder={defineMessageBorder(messages, index)}
              messageMargin={defineMessageMargin(messages, index)}
              postMessage={msg => postMessage(msg)}
              firstUnreadMessageRef={firstUnreadMessageRef}
              classes={
                message.isFromBot
                  ? 'chat__bubble chat__bubble--rcvd'
                  : 'chat__bubble chat__bubble--sent'
              }
            />
          ))
      )}

      {showIframe && (
        <Iframe
          device={device}
          src={iframeSrc}
          color={settings.color}
          close={closeIframe}
          isFullScreenWidget={isFullScreenWidget}
        />
      )}

      {showTyping && <Typing />}

      <div className={classes.bottomScrollElem} ref={messagesEnd} />
    </div>
  )
}

export default MessageContainer
